import './navBar.css';

import CartWidget from '../CartWidget';
import React from 'react';
import { NavLink } from 'react-router-dom';

export const NavBar = () => {
  //var VN1 = this.name.substring(this.name.lastIndexOf("_")+1);
  var VN1 = "pr1";

  var objLocal1 = {};
  objLocal1.pw1   = 0;

  if(objLocal1.pw1===0){objLocal1.pw1=1} else {objLocal1.pw1=0};

    const boton1 = () => {
        console.log("boton1 nav");
          document.dispatchEvent(new CustomEvent(VN1, {detail: {name: VN1, values: JSON.stringify(objLocal1) }  }));
        // const db = getFirestore();
        // const ordersCollection = collection(db, "orders");
        // addDoc(ordersCollection, order).then(({ id }) => console.log(id));
      };
    
        return (
        <div className="container">
            <nav className="nav">
                <div className="nav__brand">
                    <NavLink className="nav__link" to='/'>MiMarca</NavLink>
                    <br /> <br />
      <button onClick={boton1}>generar evento 1</button>
                </div>
                <ul className="nav__list navGrid">
                    <li>
                        <NavLink className="nav__link navItem" to='/Categoria/instalaciones'>Instalaciones</NavLink>
                    </li>
                    <li>
                        <NavLink className="nav__link navItem" to='/Categoria/sensores'>Sensores</NavLink>
                    </li>
                    <li>
                        <NavLink className="nav__link navItem" to='/AddItem'>Añadir_Item</NavLink>
                    </li>
                    <li>
                        <NavLink className="nav__link navItem" to='/iot1'>Iot_1</NavLink>
                    </li>
                    <li>
                        <NavLink className="nav__link navItem" to='/Cart'>
                            <CartWidget />
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default NavBar;